var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('b-form-radio-group',{attrs:{"id":"id","options":_vm.options,"name":"radio-options"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }